import { createContext, useContext, type ReactNode } from 'react';
import type { MarketSelectorAPI, MarketSelectorItem, MarketSelectorPreset } from '../MarketSelector/types';

export interface OldMarketSelectorItems {
  markets: string[];
  marketAccounts: string[];
}

export interface MarketDataCardMarketSelectorContextValue {
  marketSelector: MarketSelectorAPI;
  oldMarketSelectorItems: OldMarketSelectorItems;
  marketSelectorItems: MarketSelectorItem[];
  selectedMarketOrAccountNames: string[];
  selectedAggregationID: string | undefined;
  selectedAggregationLabel: string | undefined;
  favoriteAggregationPresets: MarketSelectorPreset[];
  selectAggregationPreset: (aggregationID: string) => void;
}

const MarketDataCardMarketSelectorContext = createContext<MarketDataCardMarketSelectorContextValue | undefined>(
  undefined
);

export function MarketDataCardMarketSelectorProvider({
  value,
  children,
}: {
  value: MarketDataCardMarketSelectorContextValue;
  children: ReactNode;
}) {
  return (
    <MarketDataCardMarketSelectorContext.Provider value={value}>
      {children}
    </MarketDataCardMarketSelectorContext.Provider>
  );
}

export function useMarketDataCardMarketSelectorContext() {
  const context = useContext(MarketDataCardMarketSelectorContext);
  if (context === undefined) {
    throw new Error(
      'Missing MarketDataCardMarketSelectorContext.Provider further up in the tree. Did you forget to add it?'
    );
  }
  return context;
}
